module.exports = __webpack_public_path__ + "static/img/exit_to_app.f8c5e612.svg";